import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

export const getStudentManagementConfig = (): FtuxConfig => {
	const steps: FtuxStep[] = [
		{
			type: 'modal' as const,
			headerImage: '/svg/student-management.svg',
			title: 'Welcome to Student Management',
			subtitle:
				'Manage your classes, students and book assignments all in one spot. Let’s get started and explore student management tools.',
			button: {
				label: 'Show me around',
				type: 'full-width' as const,
				hasBackButton: false
			},
			modalPosition: 'center' as const,
			hasBackdrop: true
		},
		{
			type: 'tooltip' as const,
			target: '#your-classes',
			subtitle: 'Any classes assigned to you will appear here.',
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#other-classes',
			subtitle: 'Other classes in your school will appear here.',
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#archive-classes',
			subtitle:
				'Students who have been removed will appear in the <strong>archive</strong> section.<br/><br/>If you wish to remove students permanently, you can do so within the <strong>archive</strong>. Please note that any students in the archive area will still contribute towards your the total user count for your school.',
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#add-class-button',
			subtitle: 'Lastly, you can add a new class and students here.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		}
	];

	const config: FtuxConfig = {
		id: 'student-management-ftux',
		name: 'Student Management Tutorial',
		showSkipButton: false,
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
